import { SvenskdamStandaloneExpertSlider } from '@/svenskdam/components/Expert/Slider';
import { LabradorComponent } from '@/types/component';

export const SvenskdamLabradorExpertSlider: LabradorComponent = ({ type, meta }) => <SvenskdamStandaloneExpertSlider />;
